import { useLocation } from "react-router-dom";

const FB_PATH =
  "M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12Z";
const X_PATH =
  "M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.66l-5.21-6.82-5.97 6.82H1.67l7.73-8.84L1.25 2.25h6.83l4.71 6.23 5.45-6.23Zm-1.16 17.52h1.83L7.08 4.13H5.12l11.96 15.64Z";

const Icon = ({ d }) => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden="true">
    <path d={d} />
  </svg>
);

const btn =
  "inline-flex items-center gap-2 h-9 px-4 rounded-full border border-white/10 text-white/60 hover:text-[#f4f1ea] hover:border-[#d95d39]/60 transition-colors mono-label";

export const ShareIcons = ({ label = "Share this page", testid = "footer-share", showFollow = true }) => {
  const { pathname, search } = useLocation();
  const url = encodeURIComponent(`${window.location.origin}${pathname}${search}`);

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
      <span className="mono-label text-white/40 mr-1">{label}</span>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Facebook"
        data-testid={`${testid}-facebook`}
        className={btn}
      >
        <Icon d={FB_PATH} /> Facebook
      </a>
      <a
        href={`https://x.com/intent/post?url=${url}&via=tobias_deamon`}
        onClick={(e) => {
          e.currentTarget.href = `https://x.com/intent/post?url=${url}&text=${encodeURIComponent(document.title)}&via=tobias_deamon`;
        }}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on X"
        data-testid={`${testid}-x`}
        className={btn}
      >
        <Icon d={X_PATH} /> Post on X
      </a>
      {showFollow && (
      <a
        href="https://x.com/tobias_deamon"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow @tobias_deamon on X"
        data-testid={`${testid}-follow-x`}
        className={btn}
      >
        <Icon d={X_PATH} /> Follow @tobias_deamon
      </a>
      )}
    </div>
  );
};
